import {useStore} from 'react-redux';
import {useHistory} from 'react-router-dom';
import dateformat from 'dateformat';
import { 
  convert12To24Format, 
  convertTo24HourTimeFormat 
} from '../config/utils';
import { 
  BLANK_VALUE, 
  CABS_DWEB, 
  HR, 
  PACKAGE_ID, 
  PACKAGE_TIME 
} from '../config/constants';
import { CLEAR_REVIEW_DATA } from '../pages/ReviewPage/redux/action-types';
import { createUnificationRedirectUrl } from '../utils/redirect-utils';

const useNavigate = () => {
  const history = useHistory();
  const store = useStore();
  const navigateTo = (target, isExternal = false, replace = false, others = {}) => {
    switch (target) {
      case 'srp': {
        const { common = {}, seoPage = {} } = store.getState();
        const { source = {}, startDate = {}, endDate = {}, tripType = {} , destination = {}, isSeo = false, package_id = '', source_locus = {}, destination_locus = {}, stopOvers, flow = '', isUnificationFlow = 0 } = common;
        const { date: sd = new Date(), time: sTime = '' } = startDate;
        const { date: ed = new Date(), time: eTime = '' } = endDate;
        const { rf = '', name: tname = '' } = tripType;
        const { name = '', place_id = '', city_name = '', state = '', address = '', latitude = '', longitude = '', pincode = '', google_city = '', is_city = false, is_airport = false } = source;
        const { name: dname = '', place_id: dplace_id = '', city_name: dcity_name = '', state: dstate = '', address: daddress = '', latitude: dlatitude = '', longitude: dlongitude = '', pincode: dpincode = '', google_city: dgoogle_city = '', is_city: dis_city = false, is_airport: dis_airport = false } = destination;
        const startTime = convertTo24HourTimeFormat(sTime);
        const endTime = convertTo24HourTimeFormat(eTime);

        // Check for unification flow and redirect to qa.goibibo.com
        if (isUnificationFlow) {
          const redirectUrl = createUnificationRedirectUrl({
            source,
            destination,
            startDate,
            endDate,
            rf,
            package_id,
            stopOvers
          });
          
          window.location.href = redirectUrl;
          return;
        }

        const postData = {
          s_n: name,
          s_i: place_id,
          d_n: dname,
          d_i: dplace_id,
          s_c: city_name,
          s_s: state,
          s_a: address,
          d_a: daddress,
          s_lat: latitude,
          s_long: longitude,
          d_lat: dlatitude,
          d_long: dlongitude,
          s_pin: pincode,
          d_pin: dpincode,
          s_gc: google_city,
          d_gc: dgoogle_city,
          s_is_city: is_city,
          d_is_city: dis_city,
          s_is_airport: is_airport,
          d_is_airport: dis_airport,
          s_t: `${dateformat(sd, 'yyyy-mm-dd')}T${startTime.split(' ')[0]}`,
          e_t: rf === "rt" || (rf === "ow" && stopOvers.length) ? `${dateformat(ed, 'yyyy-mm-dd')}T${endTime.split(' ')[0]}` : "",
          t_t: tname,
          fl: 'cars_dweb',
          rf,
          d_c: dcity_name,
          s_l: source_locus,
          d_l: destination_locus,
          d_s: dstate,
          off: '',
          r_off: '',
          isSeo: !!(isSeo || isExternal),
          flow
        };

        //adding package_id in url for hr page load on srp
        if (tripType?.rf === 'hr') {
          postData['d_n'] = '',
          postData['d_i'] = '',
          postData['d_c'] = '',
          postData['d_a'] = '',
          postData['d_lat'] = '',
          postData['d_long'] = '',
          postData['d_pin'] = '',
          postData['d_gc'] = '',
          postData['d_is_city'] = false,
          postData['d_is_airport'] = false,
          postData['d_l'] = '',
          postData['package_id'] = package_id
        }

        if (stopOvers.length && rf !== 'hr' && rf !== 'at') {
          const newStopOvers = stopOvers.map(details => {
            const { name = '', place_id = '', city_name = '', address = '', latitude = '', longitude = '', pincode = '', google_city = '', is_city = false, is_airport = false } = details?.value || {};
            return {
              id: details?.id,
              value: {
                place_id,
                region: city_name,
                description: name,
                address,
                latitude,
                longitude,
                pincode,
                google_city,
                is_city,
                is_airport
              }
            }
          })
          postData['stops'] = newStopOvers
        }

        const { filters = {} } = seoPage;
        let url = `/cars/review/?qryParams=${JSON.stringify(postData)}`;
        if (filters && isExternal && Object.keys(filters)?.length > 0) {
          url = `${url}&filters=${JSON.stringify(filters)}`;
        }
        if (isExternal) {
          window.location.href = url;
        }
        else if (replace) {
          history.replace(url);
        } else {
          history.push(url);
        }
        break;
      }
      case 'confirm': {
        const { srp = {}, common = {} } = store.getState();
        const { selectedCab = {} } = srp;
        const { isSeo = false, tripType = {}, package_id = '', packageTime = '', stopOvers, flow = '' } = common;
        const { dispatchSearchId = '', key = "", pc = '' } = selectedCab;
        const { rf = '', name: tname = '' } = tripType;
        const postData = {
          v_d: key,
          s_d: dispatchSearchId,
          pc,
          isSeo: !!isSeo,
          rf,
          t_t: tname,
          flow
        };

        //adding package_id in url for hr page load on srp
        if (tripType?.rf === 'hr') {
          postData['package_id']  = package_id
          postData['packageTime'] = packageTime
        }

        if (stopOvers.length && rf !== 'hr' && rf !== 'at') {
          const newStopOvers = stopOvers.map(details => {
            return {
              id: details?.id,
              value: {
                place_id: details?.value?.place_id,
                region: details?.value?.city_name,
                description: details?.value?.name
              }
            }
          })
          postData['stops'] = newStopOvers
        }

        const url = `/cars/confirm/?qryParams=${JSON.stringify(postData)}`;
        // window.location.href = url;
        store.dispatch({
          type: CLEAR_REVIEW_DATA
        })
        history.push(url);
        break;
      }
      case 'seo-to-review': {
        const { common = {}, seoPage = {} } = store.getState();
        const { source = {}, startDate = {}, endDate = {}, tripType = {} , destination = {}, package_id = '', packageTime = '', isSeo = false, flow = '' } = common;
        const { date: sd = new Date(), time: sTime = '' } = startDate;
        const { date: ed = new Date(), time: eTime = '' } = endDate;
        const { rf = '', name: tname = '' } = tripType;
        const { name = '', place_id = '', city_name = '', state = '' } = source;
        const { name: dname = '', place_id: dplace_id = '', state: dstate = ''} = destination
        const { selectedCab = {} } = seoPage;
        const { key = "",dispatchSearchId,rydeDispatchSearchId,is_ryde } = selectedCab;
        const st = convert12To24Format(sTime);
        const isRental = rf === HR
        const postData = {
          v_d: key,
          s_n: name,
          s_i: place_id,
          s_s: state,
          d_n: isRental ? BLANK_VALUE : dname,
          d_i: isRental ? BLANK_VALUE : dplace_id,
          s_t: `${dateformat(sd, 'yyyy-mm-dd')}T${st}`,
          e_t: BLANK_VALUE,
          t_t: tname,
          fl: CABS_DWEB,
          rf,
          v_t: key,
          d_s: dstate,
          is_ryde,
          isSeo: true,
          flow
        };
        if(isRental){
          postData[PACKAGE_ID] = package_id;
          postData[PACKAGE_TIME] = packageTime;
        }
        const url = `/cars/confirm/?qryParams=${JSON.stringify(postData)}`;
        window.location.href = url;
        // history.push(url);
        break;
      }
      case 'home': {
        const url = "/cars/";
        history.push(url);
        break;
      }
      
      case 'faq': {
        const url = "/cars/faq/"
        history.push(url);
        break;
      }

      case 'hob': {
        const url = "/cars/provisionalHOB/"
        history.push(url);
        break;
      }

      case 'listingHob': {
        const { hob = {} } = store.getState();
        const { flightBookingId = "", source = "", destinationLocation = {}, sourceLocation= {}, pickupTime = "", hobLandingResponse = {}, isDeparture = true} = hob;
        let url = ''
        if (flightBookingId?.length) {
          url = `/cars/listingHOB/?flightBookingId=${flightBookingId}&pickupTime=${pickupTime}&source=${source}&source_message=${hobLandingResponse?.source_message}&airport_city_code=${hobLandingResponse?.airport_city_code}&terminal=${hobLandingResponse?.terminal}&isDeparture=${isDeparture}&destinationLocation=${JSON.stringify(destinationLocation)}`;

          if (sourceLocation?.place_id?.length) {
            url += `&sourceLocation=${JSON.stringify(sourceLocation)}`;
          }
        } else {
          url = `/cars/listingHOB/?pickupTime=${pickupTime}&source=${source}&isDeparture=${isDeparture}&destinationLocation=${JSON.stringify(destinationLocation)}&sourceLocation=${JSON.stringify(sourceLocation)}`;

          if (hobLandingResponse?.source_message?.length) {
            url += `&source_message=${hobLandingResponse?.source_message}`;
          }
        }

        history.push(url);
        break;
      }

      case 'thankyouHob': {
        const url = "/cars/thankyouHOB/"
        history.push(url);
        break;
      }
      
      default:
        break;
    }
  }
  return [navigateTo];
}

export default useNavigate;
